<script setup lang="ts">
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Icon } from "@/model/icon";

defineProps<{ text: string; icon?: Icon }>();
</script>

<template>
  <SvgIcon v-if="icon" :name="icon" width="16" height="16" class="kind-icon" />
  <BaseTooltip position="top" class="text" :content="text" only-show-on-overflow>
    {{ text }}
  </BaseTooltip>
</template>

<style scoped lang="scss">
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";
@use "@/styles/mixins/utils";

.kind-icon {
  flex-shrink: 0;
  color: colors.$text-subtle;
}

.text {
  @include typography.small("regular");
  @include utils.ellipsis;

  flex: 1;
  min-width: 0;
  display: block;
  line-height: 20px;
  text-align: left;
}
</style>
